import {adminRoutes} from '../../../AppRouter/routes';

export const ADMIN_LINKS = [{
    route: adminRoutes.appNameListPage,
    title: 'App Names',
}];
